<div class="image-banner">
  <div
    [class.borderless]="borderless"
    [ngClass]="['hero', imageBackgroundClass]"
    [ngStyle]="{
      'background-image': backgroundImageSrc,
      'background-position': backgroundPosition,
      'background-size': backgroundSize
    }"
  >
    <div
      [ngClass]="['hero-inner', containerType]"
      [ngStyle]="{ 'vertical-align': verticalAlign }"
    >
      <h1 *ngIf="title">{{ title }}</h1>
    </div>
  </div>
</div>
